// extracted by css-extract-rspack-plugin
export default {"plan":"plan-FuUYwq","name":"name-FJfzv_","code":"code-wqs0D5","limits":"limits-Yi_edH"};